import React from 'react'

import appLogo from '../images/shangyu_logo.svg'

import coverImage from '../images/shangyu-cover.png'

// section images
import fish_spot from '../images/fish-spot.png'
import fish_wiki from '../images/fish-wiki.png'
import fish_community from '../images/fish-community.png'
import fish_store from '../images/fish-store.png'
import fish_explore from '../images/fish-explore.png'

export const initialState = {
    // when in dev, change appURL to local url
    // appURL: 'http://localhost:3000',
    // when in production, change appURL to real url
    appURL: 'http://localhost:3000',

    appLogo: appLogo,
    appName: '上渔App',
    supportPhone: '+86 13609990917',

    coverTitle: '你的专属钓鱼助手',
    coverText: '上渔，让上鱼变得更简单。',
    iosLink: 'https://apps.apple.com/us/app/amplichat/id1499570373',
    androidLink: 'https://www.pgyer.com/shangyu-android-d',

    coverImage: coverImage,

    sectionList: [
        {
            'title': `水域标点`,
            'lead': `打开地图，就知道哪里有鱼。`,
            'text': `钓鱼地图让你探索附近水域，识别可能出现的鱼类，还能看到同一片水域钓友们的渔获。点击某种鱼，就能拿到专属饵料推荐，出发前心里更有数。`,
            'image': fish_spot,
        },
        {
            'title': `AI 实景钓点推荐`,
            'lead': `拍下眼前的水面，AI 告诉你往哪下竿。`,
            'text': `上传或拍摄实景水域照片，AI 结合画面中的桥墩、水草、回湾、阴影区、浑清交界等特征，判断潜在藏鱼位置，再结合天气与时间段给出具体的下竿建议。`,
            'image': fish_explore,
        },
        {
            'title': `钓鱼百科`,
            'lead': `认识每一种鱼，钓前心里有底。`,
            'text': `鱼类百科为你整理各种鱼的基本信息：大小、栖息地、平均重量、濒危状况和推荐饵料，帮你更轻松地计划一次成功的出钓，也一起支持可持续垂钓。`,
            'image': fish_wiki,
        },
        {
            'title': `上渔社群`,
            'lead': `约上钓友，分享每一次渔获。`,
            'text': `在社群里和钓友交流心得、查鱼、聊天。想约钓时，选好时间和地点就能喊上朋友一起出发，出行计划更轻松，钓鱼这件事也更热闹。`,
            'image': fish_community,
        },
        {
            'title': `智能推荐商城`,
            'lead': `说出需求，装备帮你选好。`,
            'text': `商城内置 AI 智能推荐，你只要说出需求，系统就能精准匹配相关装备，省去到处比价的麻烦，还会根据你的钓鱼习惯与偏好，推荐最合适的那一件。`,
            'image': fish_store,
        },
    ],
}

const initialContext = {
    state: initialState,
    dispatch: () => null,
}

export const Context = React.createContext(initialContext)
